module.exports = __webpack_public_path__ + "img/commerce-just-logo-white.fd4c129c.svg";